import { TicketAssetsTable } from "~/pages/tickets/ticket/TicketPage/TicketAssetsSection/TicketAssetsTable";
import { AssetsProps } from "~/pages/tickets/ticket/TicketPage/TicketAssetsSection/types";
import { SectionHeading } from "~/components/DetailsPage/components";
import { Box, Grid } from "@mui/material";

export const TicketExposedAssets = ({
  assets,
  orderBy,
  urlContextType,
  contextId,
  filteredTotalCount,
  fetchMore,
  pageInfo,
  handleSortClick,
  totalCount,
  scope,
}: AssetsProps) => {
  return (
    <Grid size={12}>
      <SectionHeading heading="Assets" />
      <Box className="section-content">
        <TicketAssetsTable
          assets={assets}
          contextId={contextId}
          fetchMore={fetchMore}
          filteredTotalCount={filteredTotalCount}
          handleSortClick={handleSortClick}
          orderBy={orderBy}
          pageInfo={pageInfo}
          scope={scope}
          urlContextType={urlContextType}
          totalCount={totalCount}
        />
      </Box>
    </Grid>
  );
};
